import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setServiceType } from "../../redux/features/customer/customerSlice";

export const MainPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="flex justify-center items-center min-h-screen -mt-20">
      <div className="flex flex-row gap-8">
        {/* Delivery Button */}
        <button
          className="w-[257px] h-[162px] bg-gradient-to-br from-[#86604D] to-[#6B4A3A] rounded-xl flex flex-col items-center justify-center text-white font-bold text-2xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
          onClick={() => {
            dispatch(setServiceType("delivery"));
            navigate("/search");
          }}
        >
          <svg 
            className="w-16 h-16 mb-3 transition-transform duration-300 group-hover:scale-110" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
            <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
          </svg>
          <span>Delivery</span>
        </button>

        {/* Pick Up Button */}
        <button
          className="w-[257px] h-[162px] bg-gradient-to-br from-[#86604D] to-[#6B4A3A] rounded-xl flex flex-col items-center justify-center text-white font-bold text-2xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
          onClick={() => {
            dispatch(setServiceType("pickup"));
            navigate("/search");
          }}
        >
          <svg 
            className="w-16 h-16 mb-3 transition-transform duration-300 group-hover:scale-110" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
          </svg>
          <span>Pick Up</span>
        </button>

        {/* Catering Button */}
        <button
          className="w-[257px] h-[162px] bg-gradient-to-br from-[#86604D] to-[#6B4A3A] rounded-xl flex flex-col items-center justify-center text-white font-bold text-2xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
          onClick={() => navigate("/catering-page")}
        >
          <svg 
            className="w-16 h-16 mb-3 transition-transform duration-300 group-hover:scale-110" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
            <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
          </svg>
          <span>Catering</span>
        </button>
      </div>
    </div>
  );
};
